module.exports = __webpack_public_path__ + "img/pic-640-2.7aae98ce.webp";